const saveUserPermissions = (state = null, action) => {
    if (action.type === "SAVE_USER_PERMISSION") {
        return action.payload;
    } else {
        return state;
    }
};

export default saveUserPermissions;
